import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import AbEnvironment from '../auth/AbEnvironment';
import AppFetch from '../app/AppFetch';
import AppDefaultFetch from '../app/AppDefaultFetch'
import withStyles from '@mui/styles/withStyles';
import { Grid, List, ListItem, ListItemText, MenuItem, Paper, Radio, Switch,
         TextField, Tooltip, Typography
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import AppDisplay from '../ui/AppDisplay';
import PercentageTextField from '../ui/PercentageTextField';
import AppBindStyles from '../../AppBindStyles';
import HelpOutline from '@mui/icons-material/HelpOutline';
import AppLogo from '../ui/AppLogo';

const abEnvironment = new AbEnvironment();

function renderInputComponent(inputProps) {
   const { classes, inputRef = () => {}, ref, ...other } = inputProps;
  
  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}
  
function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.appName, query);
  const parts = parse(suggestion.appName, matches);
  
  // Is this template app or a vendor app?  
  // It is a template if it is owned by the reseller.
  // Need to distinguish between template and
  // new.
  let provisioningAccountId = abEnvironment.getUserAttribute('a_id');
  let isTemplate = false;
  //let actionText = "Select App";
  if (suggestion.accountId === provisioningAccountId) {
    if (suggestion.appId === 'customapp') {
      isTemplate = false;
      //actionText = "Select New App";
    } else {
      isTemplate = true;
      //actionText = "Select App Catalog Entry";
    }
  }
  
  let skuPart = "";
  if (suggestion.appSku != null && suggestion.appSku !== '' && suggestion.appSku !== suggestion.appName) {
    skuPart = ' (' + suggestion.appSku + ')';
  }

  // Markup or not in catalog message
  let appMessage = "";
  let ital = false;
  if (isTemplate) {
    if ((suggestion.paymentOrder === 1 || suggestion.paymentOrder === 0) && suggestion.appMarkupPercentage) {
      if (suggestion.appMarkupPercentage > 0) {
        appMessage = "Bill to customer (markup " + suggestion.appMarkupPercentage + "%)";
      } else if (suggestion.appMarkupPercentage < 0) {
        appMessage = "Bill to customer (discount " + suggestion.appMarkupPercentage + "%)";
      } else  {
        appMessage = "Bill to customer";
      }
    } else {
      appMessage = "Bill to me";
    }
  } else {
    ital = true;
    appMessage = "+ Add " + suggestion.appName;
  }

  return (
    <MenuItem selected={isHighlighted} component="div">
      <Grid container spacing={2} direction="row" justifyContent="flex-start">
        <Grid item xs={1}>
          <AppLogo logoPath={suggestion.appLogo} appName={suggestion.appName} imageHeight='24px'/>
        </Grid>
        <Grid item xs={6}>
          {/* We set the search on appname above - so that is what
              is in the part variable. */}
          <Typography variant="subtitle1">
            {parts.map((part, index) => {
              if (part.highlight && suggestion.appLogo != null) {
                return (<strong key={index}>{part.text}</strong>);
              } else {
                return (part.text);
              }
            })}
            {skuPart}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          {ital &&
          <Typography variant="subtitle1">
            <i>{appMessage}</i>
          </Typography>
          }
          {! ital &&
          <Typography variant="subtitle1">
            {appMessage}
          </Typography>
          }
        </Grid>
      </Grid>
    </MenuItem>
  );
}

const getSuggestionValue = suggestion => suggestion.appName;

//these two needed to make warnings go away in autoselect.  Should not be the case according to doc.
function getSectionSuggestions(section) {
  return null;
}

function renderSectionTitle(section) {
  return null;
}

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    container: {
      position: 'relative',
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    divider: {
      height: theme.spacing(2),
    },
    paper: {
      marginTop: 16,
      padding: theme.spacing(3),
      textAlign: 'left',
      maxWidth: 980
    },
    appTile: {
      padding: theme.spacing(2)
    },
    configGrid: {
      marginTop: 16,
    },
    percentageTextField: {
      margin: theme.spacing(1),
      marginTop: -4,
      marginLeft: 8,
      width: 65,
      minWidth: 65,
      textAlign: 'right',
      paddingLeft: 0
    },
    sectionTitleFirst: {
      marginTop: 16,
      marginBottom: -8,
    },
    sectionTitle: {
      marginTop: 8,
    },
    markupText: {
      marginTop: 4
    },
    radioLine: {
      marginTop: -12,
      marginLeft: -12
    },
    radioLine2: {
      marginTop: -26,
      marginLeft: -12
    },
    customText: {
      margin: 8
    },
    radioListItem: {
      marginTop: 0,
      marginBottom: 0,
    },
    markupList: {
      marginTop: -16,
      marginBottom: 16,
    },
    markupList2: {
      marginTop: -8,
    },
    markupBox: {
      marginLeft: 40,
      marginTop: 0,
    },
    markupDescription: {
      marginTop: -4,
    },
    textFieldNotes: {
      margin: 'theme.spacing(2)',
    }
});

class SubscriptionAppSelect extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      suggestions: [],
      searchP: ''
    }
  }

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create (select app step)'); }
  }

  handleChange = name => event => {
    if (name === 'searchP') {
      this.setState({searchP: event.target.value});
    } else {
      this.setAppCreateState({
        [name]: event.target.value,
      });  
    }
  };

  setStateFromSelection(theApp) {
    let expensingActive = false;
    let expensing = abEnvironment.getFlagValue("expensing");
    if (expensing != null && expensing.flagValue === 1) {
      expensingActive = true;
    }

    //do not allow an appname > 64!
    let appName = theApp.appName;
    if (appName.length > 64) {
      appName = appName.substring(0, 64)
    }

    // Setup the new capp...
    let paymentOrder = theApp.paymentOrder;
    if (paymentOrder == null) {
      paymentOrder = 5;
    } else {
      if (expensingActive !== true && (paymentOrder === 0 || paymentOrder === 1 || paymentOrder === 2)) {
        paymentOrder = 5;
      }
    }

    //set the default pass through fees
    let passThroughFees = theApp.passThroughFees;
    if (passThroughFees == null) {
      passThroughFees = 1;
    }

    let notesval = theApp.notes;
    if (notesval == null)
      notesval = '';

    let nobj = {
      appId: theApp.appId,
      accountId: theApp.accountId,
      appStatus: theApp.appStatus,
      parentAppId: theApp.parentAppId,
      oemAppId: theApp.oemAppId,
      appName: appName,
      appSku: theApp.appSku,
      appUrl: theApp.appUrl,
      signupUrl: theApp.signupUrl,
      appLogo: theApp.appLogo,
      description: theApp.description,
      appType: theApp.appType,
      atId: theApp.atId,
      appSkuPrice: theApp.appSkuPrice,
      appMarkupAbsolute: theApp.appMarkupAbsolute,
      appMarkupPercentage: theApp.appMarkupPercentage,
      marqetaMid: theApp.marqetaMid,
      marqetaMname: theApp.marqetaMname,
      maxCharge: theApp.maxCharge,
      paymentOrder: paymentOrder,
      passThroughFees: passThroughFees,
      wholesaleDiscountPercentage: theApp.wholesaleDiscountPercentage,
      showSubscription: 1,
      notes: notesval,
    }

    var newAppCreateStateVals = {
      cApp: nobj,
      appId: nobj.appId
    };
    this.setAppCreateState(newAppCreateStateVals);
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.fetchApps(value);
  }
    
  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []});
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) =>{
    // alert(suggestionValue);
    this.setStateFromSelection(suggestion);
  } 

  /*
   * Lookup apps for selection.  The lookup will return both template and vendor apps.  Unlike
   * usage in the app catalog, don't show vendor apps if they appear in a template.
   */
  fetchApps = (searchParm) => {
    // Provisioning account id
    let provisioningAccountId = abEnvironment.getUserAttribute('a_id');

    if (!searchParm) {
      AppDefaultFetch.fetch(provisioningAccountId, 0).toPromise()
      .then(adf => {
        this.sortAppList (provisioningAccountId, searchParm, adf.appsearchsuggestedapps2.nodes);
      })
      .catch(err => {
        this.setState({suggestions: []});
      })
    } else {
      AppFetch.fetch(provisioningAccountId, searchParm, 0, 50).toPromise()
      .then(af => {
        this.sortAppList (provisioningAccountId, searchParm, af.appsearchallavailablebyappname2.nodes);
      })
      .catch(err => {
        this.setState({suggestions: []});
      })
    }
  }

  sortAppList(provisioningAccountId, searchParm, thenodes) {
    let theApps = [];
    let templateApps = [];
    let vendorApps = [];
    let adx = 0;
    let exactMatch = false;

    // Instead of foreach, loop through using an index so that
    // we can break after showing a set number of choices.  To make
    // things more complex, as we're not showing vendor apps for which
    // a template exists, we'll iterate multiple times.
    for (let i=0; i<thenodes.length; i++)
    {
      let n = thenodes[i];
      // If it is a template app, add it.
      if (n.accountId === provisioningAccountId) {
        if (n.appName === this.state.searchP) {
          exactMatch = true;
        }
        templateApps.push(n);
      }
    }

    // Now non-template apps...
    for (let i=0; i<thenodes.length; i++)
    {
      let n = thenodes[i];

      // If it is not a template app, check if in templates.
      if (n.accountId !== provisioningAccountId)
      {
        var matchInTemplates = templateApps.find(function(anApp) {
          return (anApp.appUrl === n.appUrl &&
                  anApp.appLogo === n.appLogo)
        });

        if (! matchInTemplates)
        {
            let anApp = {
              // vApp: 1, // Indicate that this is a vendor app.  Hack to avoid showing sku
              appId: n.appId, // Set a default app id
              accountId: n.accountId,
              appStatus: n.appStatus,
              parentAppId: n.parentAppId,
              oemAppId: n.oemAppId,
              appName: n.appName,
              appSku: n.appSku, // Set a default sku
              appUrl: n.appUrl,
              signupUrl: n.signupUrl,
              appLogo: n.appLogo,
              description: n.description, //Set a default description
              appType: n.appType,
              atId: n.atId,
              appSkuPrice: n.appSkuPrice,
              appMarkupAbsolute: n.appMarkupAbsolute,
              appMarkupPercentage: n.appMarkupPercentage,
              marqetaMid: n.marqetaMid,
              marqetaMname: n.marqetaMname,
              maxCharge: n.maxCharge,
              paymentOrder: n.paymentOrder,
              wholesaleDiscountPercentage: n.wholesaleDiscountPercentage,
              notes: '',
            };
            if (n.appName === this.state.searchP) {
              exactMatch = true;
            }
            vendorApps.push(anApp);
          // }
        }
      }
    }

    // Now put these together
    let concatApps = templateApps.concat(vendorApps);

    // Sort them
    concatApps.sort(function(a, b) {
      a = a.appName;
      b = b.appName;
      return a>b ? 1 : a<b ? -1: 0; 
    });

    // Add whatever they are typing if non-blank and it does not exactly match another app
    if (this.state.searchP !== '' && !exactMatch) {
      var custApp = {
        appId: 'customapp', // Set a default app id
        accountId: provisioningAccountId,
        appStatus: 0,
        parentAppId: null,
        oemAppId: null,
        appName: searchParm,
        appSku: '', // Set a default sku
        appUrl: '',
        signupUrl: '',
        appLogo: null,
        description: '', //Set a default description
        appType: 0,
        atId: 'f5c70f86-135a-11e8-bb45-97ef56920c02',
        appSkuPrice: 0.00,
        appMarkupAbsolute: 0.00,
        appMarkupPercentage: 0,
        marqetaMid: null,
        marqetaMname: null,
        maxCharge: 1000.00,
        paymentOrder: 1,
        wholesaleDiscountPercentage: 0,
        notes: '',
      };

      theApps.push(custApp);
    }

    // Put top 10 into output array
    for (let i=0; i<concatApps.length; i++)
    {
      theApps.push(concatApps[i]);
      adx++;
      if (adx >= 10)
        break;
    }

    this.setState({suggestions: theApps});
  }

  setAppCreateStateApp = (aKey, aValue) => {
    this.props.setAppCreateStateApp(aKey, aValue);
  };

  shouldAutoRender = (value) => {
    return true;
  }
  handleRadioChange = event => {
    let theNum = parseInt(event.target.value, 10);
    this.setAppCreateStateApp("paymentOrder", theNum);
  }

  setAppCreateState = (aValue) => {
    this.props.setAppCreateState(aValue);
  };

  render() {
    const classes = this.props.classes;
    let showBilling = true;

    let wholesaleTooltip = ` Some software vendors sell partners discounted subscriptions. You in turn  then mark the subscriptions up and sell it to your customers.
                            \n\r
                            It’s important to show only the retail price for the subscription to your customer. Any discounts should come from you, which you can add on the next line below.`
    // What to show
    // - If a template/vendor app is selected, show logo, name, sku desc, and billing
    // - If a custom app is selected, show generic logo, appname field, and billing
    let showApp = false;
    let showCustom = false;
    if (this.props.cApp.appId == null) {
      showBilling = false;
    } else {
      if (this.props.cApp.appId === 'customapp')
        showCustom = true;
      else
        showApp = true;

      let usingAccountId = this.props.usingAccountId;
      let provisioningAccountId = abEnvironment.getUserAttribute('a_id');
      if (usingAccountId === provisioningAccountId) {
        showBilling = false;
      }

    }

    // For now, showing wholesale discount for all apps.  We anticipate
    // overriding this on an app by app basis in the future.
    let showWholesaleDiscount = true;

    let customerLabel = this.props.bcUser.accountName + ' will pay directly';
    let paymentFeesLabel = 'Pass payment fees to ' + this.props.bcUser.accountName;

    let inpValue = this.state.searchP;
    if (inpValue == null)
        inpValue = '';

    let expensingActive = false;
    let expensing = abEnvironment.getFlagValue("expensing");
    if (expensing != null && expensing.flagValue === 1) {
      expensingActive = true;
    }

    let actionText = 'I am adding a subscription to...';
    if (expensingActive === true) {
      actionText = 'I am buying a subscription to...';
    }

    return (
      <Paper className={classes.paper}>
        
        <Typography variant="h6" style={{marginBottom: '20px'}}>
          {actionText}
        </Typography>

        <Autosuggest
          renderInputComponent={renderInputComponent}
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionSelected={this.onSuggestionSelected}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          shouldRenderSuggestions={this.shouldAutoRender}
          multiSection={false}
          renderSectionTitle={renderSectionTitle}
          getSectionSuggestions={getSectionSuggestions}
          inputProps={{
            classes,
            placeholder: "Type the name of the subscription (e.g. the software, plugins, ad network)",
            value: inpValue,
            onChange: this.handleChange('searchP'),
          }}
          theme={{
            container: classes.container,
            suggestionsContainerOpen: classes.suggestionsContainerOpen,
            suggestionsList: classes.suggestionsList,
            suggestion: classes.suggestion,
          }}
          renderSuggestionsContainer={options => (
            <Paper {...options.containerProps} square>
              {options.children}
            </Paper>
          )}                   
        /><Search color="disabled" style={{float: "right", marginTop: -26}}/>
        <Grid container spacing={2} direction="row" justifyContent="flex-start" className={classes.configGrid}>
          { (showApp || showCustom) &&
            <Grid item xs={12}>
              <Paper className={classes.appTile}>
                <AppDisplay appLogo={this.props.cApp.appLogo}
                            appName={this.props.cApp.appName}
                            appSku={this.props.cApp.appSku}
                            description={this.props.cApp.description}/>
              </Paper>
            </Grid>
          }
          { showCustom &&
            <Grid item xs>
              <TextField
                id="app-name"
                label="App Name"
                value={this.props.cApp.appName}
                onChange={
                    (e) => {
                      this.setAppCreateStateApp("appName", e.target.value);
                    }
                } 
                inputProps={{ maxLength: 32 }}
              />
            </Grid>
          }
        </Grid>

        { showBilling &&
        <List style={{marginLeft: '-24px'}}>
          <ListItem className={classes.radioListItem}>
            <Radio
              checked={this.props.cApp.paymentOrder === 2}
              onChange={this.handleRadioChange}
              value={2}
              name='payment-source-rb'
              aria-label='Reseller'
            />
            <ListItemText primary='I will pay at my expense'/>
          </ListItem>
          {(this.props.cApp.paymentOrder === 2 && (this.props.usingAccountId !== abEnvironment.getUserAttribute('a_id'))) &&
          <ListItem className={classes.markupList}>
            <Grid container justifyContent="space-between" alignItems="center" className={classes.markupBox}>
              <Grid item>
                <Typography>Allow {this.props.bcUser.accountName} to manage this subscription</Typography>
              </Grid>
              <Grid item>
                <Switch checked={this.props.cApp.showSubscription  ? true : false}
                        onChange={(e, checked) => {
                          if (checked) {
                            this.setAppCreateStateApp("showSubscription", 1 );
                          } else {
                            this.setAppCreateStateApp("showSubscription", 0 );
                          }
                        }}
                />
              </Grid>
              <Grid item xs={12}>
                <Paper elevation={1} style={AppBindStyles.tipPaper}>
                  <Grid container spacing={1} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      <div style={{display:"flex"}}>
                        <Typography variant="body1">
                          <strong>Tip.&nbsp;&nbsp;</strong>{'If you don’t want ' + this.props.bcUser.accountName + ' to see this subscription, you can turn this off.'}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </ListItem>
          }

          <ListItem className={classes.radioListItem}>
            <Radio
              checked={this.props.cApp.paymentOrder === 1 || this.props.cApp.paymentOrder === 0}
              onChange={this.handleRadioChange}
              value={1}
              name='payment-source-rb'
              aria-label='Customer'
            />
            <ListItemText primary={customerLabel}/>
          </ListItem>
          {(this.props.cApp.paymentOrder === 1 || this.props.cApp.paymentOrder === 0) &&
          <ListItem className={classes.markupList2}>
            <Grid container spacing={1} justifyContent="space-between" alignItems="flex-start" className={classes.markupBox}>
              {showWholesaleDiscount &&
                <React.Fragment>
                  <Grid item xs={12}/>
                  <Grid item>
                    <Grid container direction="column" spacing={0}>
                      <Grid item>
                        <Typography variant="body1" style={AppBindStyles.boldLabel}>If you are buying {this.props.cApp.appName} with a partner discount, enter it here</Typography>
                      </Grid>
                      <Grid item style={AppBindStyles.markupDescription}> 
                        <Typography variant="caption">(e.g. if you’re charged $80 at a 20% discount, we’ll show the customer a retail price of $100)</Typography>
                        <Tooltip placement='bottom' title={wholesaleTooltip}>
                          <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <PercentageTextField 
                      id="wholesale-discount-percentage" className={classes.percentageTextField}
                      value={this.props.cApp.wholesaleDiscountPercentage}
                      onChange={(e) => this.setAppCreateStateApp("wholesaleDiscountPercentage", e.target.value )}
                      showErrMsg={true}
                      allowNegative={false}
                      minValue={0}
                      maxValue={100}
                      minEnterValue={0}
                      maxEnterValue={9999}
                      textAlign="right"/>

                  </Grid>
                </React.Fragment>
              }
              <Grid item xs={12}/>
              <Grid item>
                <Grid container direction="column" spacing={0}>
                  <Grid item>
                    <Typography variant="body1" style={AppBindStyles.boldLabel}>Add your management fee or discount</Typography>
                  </Grid>
                  <Grid item style={AppBindStyles.markupDescription}> 
                    <Typography variant="caption">Add a management fee (e.g. 20%) or a discount (e.g. -10%)</Typography>
                    <Tooltip placement='bottom' title={'On top of the retail price, you can add your own management fee or discount.'}>
                      <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <PercentageTextField 
                  id="app-markup-percentage" className={classes.percentageTextField}
                  value={this.props.cApp.appMarkupPercentage}
                  onChange={(e) => this.setAppCreateStateApp("appMarkupPercentage", e.target.value )}
                  allowNegative={true}
                  showErrMsg={true}
                  minValue={-100}
                  maxValue={900}
                  minEnterValue={-9999}
                  maxEnterValue={9999}
                  textAlign="right"
                />

              </Grid>
              <Grid item xs={12}/>
              <Grid item>
                <Grid container direction="column" spacing={0}>
                  <Grid item>
                    <Typography variant="body1" style={AppBindStyles.boldLabel}>{paymentFeesLabel}</Typography>
                  </Grid>
                  <Grid item style={AppBindStyles.markupDescription}> 
                    <Typography variant="caption">AppBind charges 1% plus any credit card fees</Typography>
                    <Tooltip placement='bottom' title='If funding by credit card, fees are 2.9% US and 3.9% international + $0.30'>
                      <HelpOutline fontSize="small" style={{verticalAlign: "-16%", marginLeft: '4px'}}/>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Switch checked={this.props.cApp.passThroughFees  ? true : false}
                        onChange={(e, checked) => {
                          if (checked) {
                            this.setAppCreateStateApp("passThroughFees", 1 );
                          } else {
                            this.setAppCreateStateApp("passThroughFees", 0 );
                          }
                        }}
                />
              </Grid>
              <Grid item xs={12}>
                <Paper elevation={1} style={AppBindStyles.tipPaper}>
                  <Grid container spacing={1} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      <div style={{display:"flex"}}>
                        <Typography variant="body1">
                          <strong>Tip.</strong>&nbsp;&nbsp;If you don't pass payment fees, include a markup of at least 5%.
                        </Typography>
                      </div>
                    </Grid>      
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </ListItem>
          }
          {/*  style={{padding: '16px'}} */}
        </List>
        }

        { (showApp || showCustom) &&
        <Grid container>
          <Grid item xs={12}>
            <TextField
              id="notes" label="Notes" className={classes.textFieldNotes}
              value={this.props.cApp.notes}
              fullWidth
              multiline
              onChange={(e) => this.setAppCreateStateApp("notes", e.target.value )}
            />
          </Grid>
        </Grid>
        }
      </Paper>
    );
  }
}

export default withStyles(styleSheet)(SubscriptionAppSelect);
